import { gql } from '@apollo/client';

export const GET_USERS_BY_HILDA = gql`
  query UsersByHildaId($hildaId: BigInt!, $whereHilda: WhereHilda!) {
    usersByHildaId(hildaId: $hildaId) {
      firstName
      lastName
      email
      advisorFirmId
      dateOfBirth
      phoneNumber
    }
    hilda(whereHilda: $whereHilda) {
      id
      createdAt
      name
      email
      taxId
      secondaryTaxId
      hildaTypeId
      advisor {
        firstName
        lastName
        email
        phoneNumber
      }
      address {
        streetAddress1
        city
        country
        state
        zipCode
      }
      institution {
        institutionType {
          description
        }
      }
    }
  }
`;
